export default __webpack_public_path__ + "static/media/misc-closetB-768w.9012eccd.avif";